export default __webpack_public_path__ + "static/media/CRToro.c6591721.png";